<template>
  <div>
  <v-row id="exchange-management">
    <v-col md="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr class="header-row">
              <th style="width: 5%;" class="header-text">No</th>
              <th style="width: 15%;" class="header-text">Currency Code <br/>(SAP-Business One)</th>
              <th style="width: 15%;" class="header-text">Currency Rate</th>
              <th style="width: 20%;" class="header-text">Bank</th>
              <th style="width: 20%;" class="header-text">Field</th>
              <th style="width: 20%;" class="header-text">
                <span class="tw-pl-9">
                  Active
                </span>
              </th>
              <th style="width: 15%;" class="header-text tw-text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(setting,index) in exchangeRateSettingList" :key="setting.code">
              <td>{{index+1}}</td>
              <td>
                <span>{{ setting.code }}</span>
              </td>
              <td>
                  <span>{{ setting.currencyRate }}</span>
              </td>
              <td>
                <span>{{ setting.bank }}</span>
              </td>
              <td>
                <span>
                  {{ setting.fieldName }}
                </span>
              </td>
              <td>
                <div class="tw-flex tw-items-center tw-gap-2">
                  <div :class="!setting.isActive ? 'tw-text-red-500' : 'tw-text-gray-500'">
                     OFF
                  </div>
                  <div class="tw-flex tw-items-center tw-pb-1.5">
                    <v-switch
                      v-model="{isActive: setting.isActive}.isActive"
                      :value="setting.isActive"
                      color="teal lighten-2"
                      hide-details
                      class="tw-mt-0"
                      @change="()=>{handleActiveRate(index, setting)}"
                    >
                    </v-switch>
                  </div>
                  <div :class="setting.isActive ? 'text-green' : 'tw-text-gray-500'">
                    ON
                  </div>
                </div>
              </td>
              <td>
                  <template>
                    <div class="tw-flex tw-justify-between tw-gap-2 tw-p-2">
                      <v-btn
                        color="primary"
                        icon
                        class="me-1"
                        @click="editRow(index)">
                        <v-icon>
                          mdi-pencil-box-outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="red lighten-1"
                        @click="setDeleteIndex(index)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
    <v-dialog v-model="editDialog"  max-width="480">
      <v-card  prepend-icon="mdi-account"  title="Add Exchange Rate">
        <v-card-title>
          <h3>แก้ไขอัตราแลกเปลี่ยน</h3>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="updateRate" ref="form">
            <v-row outlined dense class="tw-px-4 tw-pt-4">
              <v-text-field label="Currency Code (SAP-Business One)" v-model="editObj.code" :rules="rulesCurrencyCode" disabled required></v-text-field>
            </v-row>
            <v-row outlined dense class="tw-px-4">
              <v-text-field label="Currency Rate" v-model="editObj.currencyRate" :rules="rulesCurrencyRate" required></v-text-field>
            </v-row>
            <v-row class="tw-px-4 tw-pt-2">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                :items="banks"
                outlined
                dense
                v-model="editObj.bank"
                label="Bank"
                :rules="rulesBank"
              >
              </v-select>
            </v-row>
            <v-row class="tw-px-4">
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                :items="fieldType"
                outlined
                dense
                v-model="editObj.fieldName"
                label="Field"
                :rules="rulesFild"
              >
              </v-select>
            </v-row>
            <v-row class="tw-px-5 tw-pb-3">
              <div class="tw-flex tw-flex-col">
                <label>Active</label>
                <div class="tw-flex tw-items-center tw-gap-2">
                  <div :class="!editObj.isActive ? 'tw-text-red-500' : 'tw-text-gray-500'">
                    OFF
                  </div>
                  <div class="tw-flex tw-items-center tw-pb-1.5">
                    <v-switch
                      v-model="editObj.isActive"
                      color="teal lighten-2"
                      hide-details
                      class="tw-mt-0"
                    >
                    </v-switch>
                  </div>
                  <div :class="editObj.isActive ? 'text-green' : 'tw-text-gray-500'">
                    ON
                  </div>
               </div>
              </div>
            </v-row>
            <v-row class="tw-flex tw-justify-between tw-p-4">
              <v-btn outlined class="me-1" @click="()=>{editDialog = false; cancelEdit()}">
                ยกเลิก
              </v-btn>
              <v-btn :loading="isUpdating" :disabled="isUpdating" color="primary" type="submit" variant="tonal" @click="updateRate">
                บันทึก
              </v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card prepend-icon="mdi-account" title="Delete Exchange Rate">
        <v-card-title>
          <h3>คุณต้องการลบอัตราแลกเปลี่ยน {{deleteObj.code}} ใช่หรือไม่?</h3>
        </v-card-title>
        <v-card-text>
          <v-row class="tw-flex tw-justify-between tw-p-4">
            <v-btn outlined class="me-1" @click="deleteDialog = false">
              ยกเลิก
            </v-btn>
            <v-btn :loading="isUpdating" :disabled="isUpdating" outlined color="error" type="submit" variant="tonal" @click="deleteRate">
              ลบ
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      top
      :color="snackbarColor"
      timeout="2000"
      class="tw-text-center"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import exchangeRate from "@/store/collection/exchange-rate";

export default {
  name: "ExchangeManagement",
  components: {
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      editingIndex: null,
      unsubscribe: [],
      editDialog: false,
      editObj: {
        code: '',
        currencyRate: '',
        bank: '',
        field: '',
        fieldName: '',
        isActive: true
      },
      isUpdating: false,
      updateIndex: null,
      deleteIndex: null,
      deleteDialog: false,
      deleteObj: {
        code: '',
        currencyRate: '',
        bank: '',
        field: '',
        isActive: true
      },
      rulesCurrencyCode: [
        (v) => !!v || "Currency Code is required",
      ],
      rulesCurrencyRate: [
        (v) => !!v || "Currency Rate is required",
      ],
      rulesBank: [
        (v) => !!v || "Bank is required",
      ],
      rulesFild: [
        (v) => !!v || "Field is required",
      ],
      fieldType: [],
    };
  },
  computed: {
    ...(mapState({
    users: state => state.user.list,
    userCompany: state => state.user.userCompany,
    exchangeRateSettingList: state => state.exchangeRate.exchangeRateSettingList,
    banks: state => state.exchangeRate.bankList.map(bank => bank.code),
  }))
},
  watch: {
    "editObj.bank": async function(val) {
      if (val !== '') {
        this.fieldType = await this.$store.dispatch('exchangeRate/getBankFieldListValue', val);
      } else {
        this.fieldType = [];
      }
    },

  },
  methods: {
    async loadExchangeRates() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        const collectionSetting= fc.db.collection(`Companies/${companyId}/ExchangeRate`).doc('setting')
        this.unsubscribe.push(collectionSetting.onSnapshot(async (doc) => {
          const objData = doc.data()?.currency || {};
          const r = []
          for (let obj in objData) {
            objData[obj].code = obj
            r.push(objData[obj])
          }
          r.sort((a, b) => a.code.localeCompare(b.code));
          await this.$store.dispatch("exchangeRate/setExchangeRateSettingList", r,);
        }, (error) => {
          console.error("Error getting document:", error);
          this.$store.dispatch("exchangeRate/setExchangeRateSettingList", []);
        }));
      }
    },
    editRow(index) {
      this.editObj = {...this.exchangeRateSettingList[index]}
      this.editingIndex = index
      this.editDialog = true
    },
    cancelEdit(){
      this.editDialog = false
      this.editingIndex= null
      this.editObj = {
        code: '',
        currencyRate: '',
        bank: '',
        field: '',
        fieldName: '',
        isActive: true
      }
    },
    async updateRate(){
      this.isUpdating = true;
      const setting = this.editObj;
      const companyID = this.$route.params.companyId;
      try {
        const fieldKey = await this.$store.dispatch('exchangeRate/getFieldByBankAndFieldName', {
          fieldName: this.editObj.fieldName,
          bankName: this.editObj.bank
        });
        // const fieldKey = "dfsa"
      const docRef =fc.db.collection(`Companies/${companyID}/ExchangeRate`).doc('setting');
        // Update the Firebase document
          await docRef.set( {
          [`currency`]: {
              [setting.code]:{
                bank:setting.bank,
                currencyRate: setting.currencyRate,
                field: fieldKey,
                fieldName: setting.fieldName,
                isActive: setting.isActive
              }
            }
          },{merge:true});
        this.snackbarText = `แก้ไขอัตราแลกเปลี่ยน ${setting.code} สำเร็จ`;
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error("Error updating document: ", error);
      } finally {
        this.cancelEdit()
        this.isUpdating = false;
      }
    },
    setDeleteIndex(index) {
      this.deleteIndex = index
      this.deleteObj = {...this.exchangeRateSettingList[index]}
      this.deleteDialog = true
    },
    async deleteRate() {
      this.isUpdating = true;
      const setting = this.deleteObj;
      const companyID = this.$route.params.companyId;
      try {
        const data = this.exchangeRateSettingList.map(i=>i).filter((item, i) => i !== this.deleteIndex);
        const docRef =fc.db.collection(`Companies/${companyID}/ExchangeRate`).doc('setting');
        let currency = {}
        data.forEach(item => {
            currency[item.code] = {
            bank:item.bank,
            currencyRate: item.currencyRate,
            field: item.field,
            fieldName: item.fieldName,
            isActive: item.isActive
          }
        });
        await docRef.set({ currency },{merge:false});

        this.snackbarText = `ลบอัตราแลกเปลี่ยน ${setting.code} สำเร็จ`;
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error("Error deleting document: ", error);
      } finally {
        this.deleteDialog = false
        this.isUpdating = false;
      }
    },
    getFieldValue(bank, field) {
      const objList = this.fieldType.find(field => field.bankName === bank)
      return objList[field];
    },
    async handleActiveRate(index, data) {
      this.editObj = {
        ...data,
        isActive: !data.isActive
      }
      await this.updateRate()
    }
  },
  beforeDestroy() {
    this.$store.dispatch("user/getUserListUnsubscribe");
    this.unsubscribe.forEach((unsubscribe) => {
      unsubscribe();
    });
  },
  async created() {
    await this.loadExchangeRates()
  }
};
</script>
<style lang="scss">
  .text-green {
    color: #4DB6AC;
  }
</style>
